import {combineReducers} from 'redux'
import {createReducer} from 'util/redux'
import {dqButtonErrorAction, dqButtonLoadingAction, dqButtonResponseAction, resetDqButtonsAction} from 'module/DqButton/action/DqButtonsAction'
import _ from 'lodash'
import {DqButton} from 'generated/JavaTOmodifications'
import {DqButtonLocation} from 'module/DqButton/type/DqButtonLocations'

type DqButtonByLocationType = { [location in DqButtonLocation]?: DqButton[] }

const byLocation = createReducer<DqButtonByLocationType>({}, builder => builder
	.addCase(resetDqButtonsAction, (state, {payload}) =>
		_.groupBy(_.sortBy(payload, ['location', 'position']), 'location'),
	),
)

type DqButtonActionType = { payload: { dqButton: DqButton } }
const addDqButtonToIdList = (state: number[], {payload}: DqButtonActionType) => [...state, payload.dqButton.id]
const removeDqButtonFromIdList = (state: number[], {payload}: DqButtonActionType) => state.filter(id => id !== payload.dqButton.id)

const loading = createReducer<number[]>([], builder => builder
	.addCase(dqButtonLoadingAction, addDqButtonToIdList)
	.addCase(dqButtonResponseAction, removeDqButtonFromIdList)
	.addCase(dqButtonErrorAction, removeDqButtonFromIdList),
)

const error = createReducer<Record<number, string>>({}, builder => builder
	.addCase(dqButtonErrorAction, (state, {payload}) => ({
		...state,
		[payload.dqButton.id]: payload.error + '',
	}))
	.addCase(dqButtonResponseAction, (state, {payload}) =>
		_.omit(state, payload.dqButton.id),
	),
)

export const DqButtonReducerNS = {
	DqButton: combineReducers({
		byLocation,
		transient: combineReducers({
			loading,
			error,
		}),
	}),
}
export type DqButtonStateType = { DqButton: ReturnType<typeof DqButtonReducerNS.DqButton> }